
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getEnv } from "../utils/env";

const firebaseConfig = {
  apiKey: getEnv("NEXT_PUBLIC_FIREBASE_API_KEY") || getEnv("EXPO_PUBLIC_FIREBASE_API_KEY") || "AIzaSyC95wZkdDom4yCdTu1rmIGb4OiLQq4mbQk",
  authDomain: getEnv("NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN") || getEnv("EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN") || "medinter-nhs.firebaseapp.com",
  projectId: getEnv("NEXT_PUBLIC_FIREBASE_PROJECT_ID") || getEnv("EXPO_PUBLIC_FIREBASE_PROJECT_ID") || "medinter-nhs",
  storageBucket: getEnv("NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET") || getEnv("EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET") || "medinter-nhs.firebasestorage.app",
  messagingSenderId: getEnv("NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID") || getEnv("EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID") || "74576328684",
  appId: getEnv("NEXT_PUBLIC_FIREBASE_APP_ID") || getEnv("EXPO_PUBLIC_FIREBASE_APP_ID") || "1:74576328684:web:4631bf144a0d158d42f2c9",
  measurementId: getEnv("NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID") || getEnv("EXPO_PUBLIC_FIREBASE_MEASUREMENT_ID") || "G-5RD2S0LF58"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storageBucket = getStorage(app);
export const isFirebaseConfigured = true;
